export default {
	BLUR: 'suggest.blur',
	CANCEL: 'suggest.cancel',
	CLOSE: 'suggest.list.close',
	NORESULTS: 'suggest.noresults',
	OPEN: 'suggest.list.open',
	SEARCHING: 'suggest.searching',
	SELECTED: 'suggest.item.selected',
	CLEAR: 'suggest.item.clear',
};
